import { createTheme, DEFAULT_THEME, SegmentedControl } from '@mantine/core';
import { produce } from 'immer';

export const theme = createTheme(
  produce(DEFAULT_THEME, (draft) => {
    draft.fontFamily = 'Mona Sans';
    draft.fontFamilyMonospace = 'Geist Mono';
    draft.autoContrast = true;
    draft.defaultRadius = 'xs';
    draft.cursorType = 'pointer';
    draft.primaryColor = 'blue';
    draft.primaryShade = { dark: 8, light: 6 };

    const darkColor = '#0b141b';
    const darkFactors = [
      [10, 0], // force pure white
      [0.63, 0.96],
      [0.56, 1.28],
      [0.49, 1.6],
      [0.42, 2.24],
      [0.32, 2.24],
      [0.28, 2.24],
      [0.24, 1.92],
      [0.21, 1.6],
      [0.17, 1.6],
    ] as const;

    const darkAccentColor = '#242b45';
    const darkAccentFactors = [
      [0.9, 0.72],
      [0.9, 0.72],
      [0.8, 0.96],
      [0.7, 1.2],
      [0.6, 1.68],
      [0.45, 1.68],
      [0.4, 1.68],
      [0.35, 1.44],
      [0.3, 1.2],
      [0.25, 1.2],
    ] as const;

    draft.components.SegmentedControl = SegmentedControl.extend({
      defaultProps: {
        color: 'blue',
      },
    });

    draft.other = {
      backgroundDark: 'oklch(from var(--mantine-color-dark-9) calc(l * 0.5) c h)',
      darkHueOffset: 20,
      darkAccentHueOffset: -20,
      color: {
        dark: darkFactors.map(
          ([lFactor, cFactor]) =>
            `oklch(from ${darkColor} ${lFactor} calc(c * ${cFactor}) calc(h + var(--theme-dark-hue-offset, 0)))`,
        ),
        darkAccent: darkAccentFactors.map(
          ([lFactor, cFactor]) =>
            `oklch(from ${darkAccentColor} ${lFactor} calc(c * ${cFactor}) calc(h + var(--theme-dark-accent-hue-offset, 0)))`,
        ),
      },
      fontWidth: {
        md: 100,
        lg: 110,
        xl: 120,
        sm: 95,
        xs: 80,
      },
    };

    draft.colors.dark = Array.from(
      { length: darkFactors.length },
      (_, i) => `var(--theme-color-dark-${i + 1})`,
    ) as (typeof draft.colors)[string];
    draft.colors['dark-accent'] = Array.from(
      { length: darkAccentFactors.length },
      (_, i) => `var(--theme-color-dark-accent-${i + 1})`,
    ) as (typeof draft.colors)[string];
  }),
);
